<div class="app-shell">

  <app-side-bar></app-side-bar>

  <div class="app-main">

    <app-header></app-header>

    <main class="app-content">
      <router-outlet></router-outlet>
    </main>

    <app-footer></app-footer>

  </div>

</div>
